<template>
  <div>
    <Head :title="title" />
    <div class="bg-white rounded-md shadow overflow-hidden w-full">
      <form @submit.prevent="update">
        <div class="p-8 -mr-6 -mb-8 flex flex-wrap">
          <text-input v-model="form.date" :error="form.errors.date" type="date" class="pr-6 pb-8 w-full lg:w-1/2" :label="__('Date')" />

          <div class="pr-6 pb-8 w-full">
            <label class="form-label mb-6">{{ __('Details') }}:</label>
            <div v-for="(detail, index) in form.details" :key="index" class="flex items-center space-x-4 mb-4">
              <select-input v-model="detail.asset_id" :error="form.errors[`details.${index}.asset_id`]" class="pr-6 pb-8 w-full lg:w-1/2" :label="__('Asset')" :required="true" @change="updateAssetDetails(detail, index)">
                <option :value="null">{{ __('Select Asset') }}</option>
                <option v-for="s in asset" :key="s.id" :value="s.id">{{ s.name }}</option>
              </select-input>
              <text-input v-model="detail.code" :error="form.errors[`details.${index}.code`]" class="pr-6 pb-8 w-full lg:w-1/2" :label="__('Code Asset')" readonly />
              <text-input v-model="detail.brand" :error="form.errors[`details.${index}.brand`]" class="pr-6 pb-8 w-full lg:w-1/2" :label="__('Brand')" readonly />
              <text-input v-model="detail.type" :error="form.errors[`details.${index}.type`]" class="pr-6 pb-8 w-full lg:w-1/2" :label="__('Type')" readonly />
              <text-input v-model="detail.serial_number" :error="form.errors[`details.${index}.serial_number`]" class="pr-6 pb-8 w-full lg:w-1/2" :label="__('Serial Number')" readonly />
              <text-input v-model="detail.qty" :error="form.errors[`details.${index}.qty`]" type="number" min="1" class="pr-6 pb-8 w-full lg:w-1/2" :label="__('Qty')" @input="validateQty(detail, index)" />
              <button type="button" @click="removeDetail(index)" class="text-red-500">
                {{ __('Remove') }}
              </button>
            </div>
            <button type="button" @click="addDetail" class="text-blue-500">
              {{ __('Add another asset') }}
            </button>
          </div>
        </div>
        <div class="px-8 py-4 bg-gray-50 border-t border-gray-100 flex items-center">
          <loading-button :loading="form.processing" class="btn-indigo ml-auto" type="submit">
            {{ __('Update') }}
          </loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

  <script>
import Layout from '@/Shared/Layout'
import { Head } from '@inertiajs/vue3'
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import { formatDate } from '@/utils/dateFormatter.js'

export default {
  metaInfo() {
    return { title: this.title }
  },
  components: {
    LoadingButton,
    TextInput,
    SelectInput,
    Head,
  },
  layout: Layout,
  props: {
    title: String,
    data_incoming_goods: Object,
    asset: Array,
  },
  data() {
    return {
      form: this.$inertia.form({
        date: formatDate(this.data_incoming_goods.date, 'YYYY-MM-DD'),
        details: this.data_incoming_goods.details.map((detail) => ({
          asset_id: detail.asset_id,
          code: detail.code,
          brand: detail.brand,
          type: detail.type,
          serial_number: detail.serial_number,
          qty: detail.qty,
        })),
      }),
    }
  },
  methods: {
    update() {
      this.form.put(this.route('incoming_goods.update', this.data_incoming_goods.id))
    },
    validateQty(detail, index) {
      if (detail.qty < 1) {
        this.form.errors[`details.${index}.qty`] = 'Quantity must be at least 1'
      }
    },
    updateAssetDetails(detail, index) {
      // Find the selected asset based on asset_id
      const selectedAsset = this.asset.find((asset) => asset.id === detail.asset_id)

      if (selectedAsset) {
        // Update fields with the asset details
        detail.code = selectedAsset.code
        detail.brand = selectedAsset.brand
        detail.type = selectedAsset.type
        detail.serial_number = selectedAsset.serial_number

        // Check for duplicate asset_id in details
        const existingDetailIndex = this.form.details.findIndex((d) => d.asset_id === detail.asset_id && d !== detail)

        if (existingDetailIndex !== -1) {
          // Increment qty of the existing detail
          this.form.details[existingDetailIndex].qty += detail.qty

          // Remove the current detail to avoid duplication
          this.form.details.splice(index, 1)
        }
      }
    },
    addDetail() {
      this.form.details.push({
        asset_id: null,
        code: '',
        brand: '',
        type: '',
        serial_number: '',
        qty: 1,
      })
    },
    removeDetail(index) {
      this.form.details.splice(index, 1)
    },
  },
}
</script>
